import styled from 'styled-components';

import { BUTTON_SIZES, PrimaryButton } from 'ui/button';
import { Modal, ModalFooter, ModalBody, ModalHeader, MODAL_SIZES, MODAL_VARIANTS } from 'ui/modal';
import { fontWeights } from 'ui/theme';
import { useResendMessageMutation } from '../hooks/useResendMessageMutation';
import { useEventHistoryModalsContext } from './contexts/EventHistoryModalsContext';
import { useUserKeyParameter } from '../../hooks';

const displayText = {
  title: 'Resend message?',
  confirm: 'Resend message',
};

const CampaignName = styled.span`
  font-weight: ${fontWeights.bold};
`;

export const ResendMessageModal = () => {
  const userId = useUserKeyParameter(true);
  const { closeModal, isResendMessageModalVisible, resendMessageModalOptions } =
    useEventHistoryModalsContext();
  const [resendMessage] = useResendMessageMutation(userId);

  if (!isResendMessageModalVisible || !resendMessageModalOptions) {
    return null;
  }

  const handleConfirm = () => {
    resendMessage(
      resendMessageModalOptions?.messageId,
      resendMessageModalOptions?.campaign.messageMedium,
    );
    closeModal();
  };
  return (
    <Modal
      id="resend-message"
      withPortal
      isModalOpen
      onClose={closeModal}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.WARNING}
    >
      <ModalHeader>{displayText.title}</ModalHeader>
      <ModalBody data-test="resend-message-modal-body">
        Are you sure that you want to resend the email for{' '}
        <CampaignName>{resendMessageModalOptions?.campaign.name}</CampaignName>?
      </ModalBody>
      <ModalFooter>
        <PrimaryButton
          onClick={handleConfirm}
          data-test="confirm-resend-button"
          size={BUTTON_SIZES.LARGE}
        >
          {displayText.confirm}
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  );
};
